<template>
  <div>
    <vue-headful :title="appTitle" />

    <router-view />

    <md-dialog-alert
      :md-active="dialog.alert.show"
      :md-content="dialog.alert.content"
      md-confirm-text="OK"
      @update:mdActive="$store.dispatch('dialog/closeAlert')"
      style="z-index: 10000"
    />

    <md-dialog-confirm
      :md-active="dialog.confirm.show"
      :md-content="dialog.confirm.content.message"
      :md-confirm-text="dialog.confirm.content.confirmText"
      :md-cancel-text="dialog.confirm.content.cancelText"
      @md-confirm="dialog.confirm.content.action"
      @update:mdActive="$store.dispatch('dialog/closeConfirm')"
    />

    <spinner v-if="spinner.modal.show" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Spinner from '@/components/Spinner'

export default {
  components: {
    Spinner,
  },

  computed: {
    ...mapState({
      dialog: (state) => state.dialog,
      spinner: (state) => state.spinner,
    }),

    appTitle() {
      return `${this.$config.title.text}${this.$config.title.suffix}`
    },
  },
}
</script>

<style lang="scss">
@import './assets/scss/app.scss';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
